import { defineMessages } from 'react-intl';

export const sellingPointsMessages = defineMessages({
  articleNumber: {
    id: 'product.articleNumber',
    defaultMessage: 'Art.-Nr.: {data}',
  },
});
